const primaryButtonTokens = {
    focusRing: {
        color: '{root.focus.ring.color}'
    }
};
const secondaryButtonTokens = {
    color: '{primary.color}',
    hoverColor: '{primary.hover.color}',
    activeColor: '{primary.active.color}',
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    borderColor: '{primary.color}',
    hoverBorderColor: '{primary.hover.color}',
    activeBorderColor: '{primary.active.color}',
    focusRing: {
        color: '{root.focus.ring.color}'
    }
};
const tertiaryButtonTokens = {
    color: '{primary.active.color}',
    hoverColor: '{primary.hover.color}',
    activeColor: '{navy.800}',
    background: '{button.secondary.background}',
    hoverBackground: '{button.secondary.hover.background}',
    activeBackground: '{button.secondary.active.background}',
    borderColor: '{slate.100}',
    hoverBorderColor: '{primary.hover.color}',
    activeBorderColor: '{navy.700}',
    focusRing: {
        color: '{root.focus.ring.color}'
    }
};
const tertiaryButtonCss = ({ dt }) => `
    .p-button-tertiary {
        color: ${dt('button.tertiary.color')};
        background: ${dt('button.tertiary.background')};
        border-color: ${dt('button.tertiary.borderColor')};
    }
    .p-button-tertiary:not(:disabled):hover {
        color: ${dt('button.tertiary.hover.color')};
        background: ${dt('button.tertiary.hover.background')};
        border-color: ${dt('button.tertiary.hover.borderColor')};
    }
    .p-button-tertiary:not(:disabled):active {
        color: ${dt('button.tertiary.active.color')};
        background: ${dt('button.tertiary.active.background')};
        border-color: ${dt('button.tertiary.active.borderColor')};
    }
`;
const linkButtonTokens = {
    color: '{primary.active.color}',
    hoverColor: '{primary.hover.color}',
    activeColor: '{primary.active.color}',
};
const linkButtonCss = () => `
    .p-button-link .p-button-label {
        text-decoration: underline;
    }
`;
const outlinedSecondaryButtonTokens = {
    color: '{primary.color}',
    borderColor: '{primary.color}',
    activeBackground: '{highlight.focus.background}',
    hoverBackground: 'transparent'
};
export const buttonTokens = {
    colorScheme: {
        light: {
            root: {
                primary: primaryButtonTokens,
                secondary: secondaryButtonTokens,
            },
            link: linkButtonTokens,
            outlined: {
                secondary: outlinedSecondaryButtonTokens
            }
        }
    },
    extend: {
        tertiary: tertiaryButtonTokens
    },
    css: (options) => `
        ${tertiaryButtonCss(options)}
        ${linkButtonCss()}
    `
};
